<div
  class="custom-flex-row flex-gap-px-8 ion-align-items-stretch ion-justify-content-between">
  <ion-button
    data-btn="decrease-btn"
    class="chevron-btn"
    mode="md"
    expand="block"
    [disabled]="isMin"
    (click)="decrease()">
    <fa-icon [icon]="faChevronLeft"></fa-icon>
  </ion-button>

  <ion-button
    [ngClass]="{
      calendar: true,
      'pointer-events-none': !showDatePicker
    }"
    mode="md"
    (click)="picker.open()">
    <div
      class="custom-flex-row flex-gap-px-8 ion-align-items-center ion-justify-content-center">
      <fa-icon [icon]="faCalendar"></fa-icon>
      <span class="font-bold capitalize">{{ dateDisplay }}</span>
    </div>

    <div class="calendar-date-picker" *ngIf="showDatePicker">
      <input
        class="picker-input"
        matInput
        [value]="currentDateString"
        [matDatepicker]="picker"
        (dateChange)="onDatePickerSelect($event)"
        [min]="minDate"
        [max]="maxDate" />
    </div>
    <mat-datepicker #picker></mat-datepicker>
  </ion-button>

  <ion-button
    data-btn="increase-btn"
    class="chevron-btn"
    mode="md"
    expand="block"
    [disabled]="isMax"
    (click)="increase()">
    <fa-icon [icon]="faChevronRight"></fa-icon>
  </ion-button>
</div>
